import * as React from "react";
import type { SVGProps } from "react";
export const SvgYearInReviewGold = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M22.21 10.205c0-3.013-3.477-5.455-7.769-5.455-3.516 0-6.486 1.641-7.444 3.892-3.031.743-5.208 2.768-5.208 5.15 0 3.013 3.479 5.456 7.77 5.456 3.516 0 6.486-1.642 7.444-3.892 3.032-.744 5.208-2.768 5.208-5.151ZM9.56 17.452c-3.182 0-5.971-1.709-5.971-3.657 0-1.323 1.288-2.533 3.108-3.177.299 2.82 3.652 5.045 7.745 5.045.062 0 .126 0 .188-.003-1.074 1.055-2.984 1.792-5.07 1.792Z"
    />
  </svg>
);
